import React, { useState, useEffect, useRef } from 'react';
import { Admission, LastStep, Pdpa, ServiceAgreement, ServiceAgreementAcceptance, ServiceAgreementSchedule1, ServiceAgreementSchedule2, ServiceAgreementSchedule3 } from './steps_forms';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { admissionStates } from '../../constant/steps_form_fields';
import '../../styles/rc_forms.css';
import { createForm, fetchFormById } from '../../api';
import { handleCreateForm, handleGetForm, handleUpdateForm } from '../../api/rc_admission_form';
import StepIndicator, { Step } from '../../component/step_indicator';
import { co_acceptance_type, co_witness_type, cr_acceptance_type, cr_witness_type, guest_checkin_type, guest_checkout_type, pdpa_co_type, staff_checkin_type, staff_checkout_type, titleText } from '../../constant/common_use';
import { useStateContext } from '../../contexts/StepFormContextProvider';

const RCAdmission = () => {
	const [currentStep, setCurrentStep] = useState(1);
	const stepIndicatorsRefs = useRef([]);

	//context providers
	const { setFormId, setUserId, formId } = useStateContext();

	//admin
	const [isAdmin, setIsAdmin] = useState(true);
	const [customerId, setCustomerId] = useState(null);
	const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

	//formVal
	const [formValues, setFormValues] = useState(admissionStates);
	console.log(formValues)

	// Refs for all StepIndicator elements
	useEffect(() => {
		stepIndicatorsRefs.current = stepIndicatorsRefs.current.slice(0, titleText.length);
	}, []);

	// Effect to scroll to current step
	useEffect(() => {
		if (stepIndicatorsRefs.current[currentStep - 1]) {
			stepIndicatorsRefs.current[currentStep - 1].scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center',
			});
		}
	}, [currentStep]);

	//still working on the get and synchronize with localStorage data.
	useEffect(() => {
		const queryParams = (new URL(document.location)).searchParams;
		const customerId = queryParams.get('customer_id');
		setCustomerId(customerId);
		const type = queryParams.get('type');

		if (type == "staff") {
			setIsAdmin(true);
		} else if(type == "client") {
			setIsAdmin(false);
		} else {
			alert("Invalid Link");
			return;
		}

		//simulate customer id from url
		formValues.customer_id = customerId;

		const fetchForm = async () => {
			try {
				let customerForm = await handleGetForm(customerId);
				const checkIfCustomerExists = checkForIdKey(customerForm[0]);

				if(checkIfCustomerExists) {
					setFormValues(customerForm[0]);
					setUserId(customerForm[0].customer_id);
					setFormId(customerForm[0].id);
				} else {
					//create new form
					let newForm = { "customer_id": customerId }
					await handleCreateForm(newForm);
				}
				return customerForm[0];
			} catch (error) {
				console.log(error);
			}
		}

		fetchForm();
	}, []);

	const checkForIdKey = (data) => {
		const objKey = Object.keys(data);
		const id = objKey.includes("id");
		const customerId = objKey.includes("customer_id");

		if(id === true && customerId === true) {
			return true;
		} else return false;
	}

	const handleUpdateSignature = async (type, field, value, name, ic_passport, position, date) => {
		if(type === staff_checkin_type || type === staff_checkout_type || type === guest_checkin_type || type === guest_checkout_type) {

			const updatedSignatures = formValues.signatures.map((signature) =>
				signature.type === type ? {
					...signature,
					[field]: value,
					id: signature.id !== '' ? signature.id : formId
				} : signature
			);

			const updatedVal = updatedSignatures.filter(item => item.type === type);

			setFormValues({ ...formValues, signatures: updatedSignatures });
			const res = handleUpdateForm(formId, { signatures: updatedVal });

			if(res.status === 200) {
				return true;
			} else {
				return false;
			}
		} else if(type === cr_acceptance_type || type === cr_witness_type || type === co_acceptance_type || type === co_witness_type || type === pdpa_co_type) {
			const updatedSignatures = formValues.signatures.map((signature) =>
				signature.type === type ? {
					...signature, [field]: value, 'name': name, 'ic_passport': ic_passport
				} : signature
			);

			const updatedVal = updatedSignatures.filter(item => item.type === type);

			setFormValues({ ...formValues, signatures: updatedSignatures });
			const res = handleUpdateForm(formId, { signatures: updatedVal });

			if(res.status === 200) {
				return true;
			} else {
				return false;
			}
		} else {
			const updatedSignatures = formValues.signatures.map((signature) =>
				signature.type === type ? {
					...signature,
					[field]: value,
					'name': name,
					'ic_passport': ic_passport,
					id: signature.id !== '' ? signature.id : formId
				} : signature
			);

			const updatedVal = updatedSignatures.filter(item => item.type === type);
			const res = await handleUpdateForm(formId, { signatures: updatedVal });

			setFormValues({ ...formValues, signatures: updatedSignatures });

			if(res.status === 200) {
				return true;
			} else {
				return false;
			}
		}
	};

	const getSignature = (type) => {
		if(formValues.signatures !== null && formValues.signatures !== undefined) {
			return formValues.signatures.find((signature) => signature.type === type);
		}
	}

	const totalSteps = 8;
	const completionPercentage = currentStep === 1 ? 0 : Math.round((currentStep / totalSteps) * 100);

	return (
		<div style={{ textAlign: 'center', overflowX: 'hidden', marginLeft: 'auto', marginRight: 'auto', width: '100%', maxWidth: '1280px', padding: '0 2rem' }}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-around',
					alignItems: 'start',
					marginBottom: '20px',
					overflowX: 'auto',
					width: '100%',
				}}
			>
				{[...Array(totalSteps).keys()].map((index) => (
					<StepIndicator
						key={index}
						stepNumber={index + 1}
						currentStep={currentStep}
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep}
						isScrolledToBottom={isScrolledToBottom}
						setIsScrolledToBottom={setIsScrolledToBottom}
						ref={(el) => (stepIndicatorsRefs.current[index] = el)}
					/>
				))}
			</div>

			<div style={{ marginBottom: '20px' }}>
				<p style={{ fontSize: '18px', color: '#6f42c1', fontWeight: '700' }}>
					COMPLETENESS {completionPercentage}%
				</p>
			</div>

			<LocalizationProvider dateAdapter={AdapterMoment}>
				<Step stepNumber={1} currentStep={currentStep}>
					<Admission
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
						handleUpdateSignature={handleUpdateSignature} getSignature={getSignature}
					/>
				</Step>

				<Step stepNumber={2} currentStep={currentStep}>
					<ServiceAgreement
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						isScrolledToBottom={isScrolledToBottom} setIsScrolledToBottom={setIsScrolledToBottom}
					/>
				</Step>

				<Step stepNumber={3} currentStep={currentStep}>
					<ServiceAgreementSchedule1
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
					/>
				</Step>

				<Step stepNumber={4} currentStep={currentStep}>
					<ServiceAgreementSchedule2
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
					/>
				</Step>

				<Step stepNumber={5} currentStep={currentStep}>
					<ServiceAgreementSchedule3
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
						handleUpdateSignature={handleUpdateSignature} getSignature={getSignature}
					/>
				</Step>

				<Step stepNumber={6} currentStep={currentStep}>
					<ServiceAgreementAcceptance
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
						handleUpdateSignature={handleUpdateSignature} getSignature={getSignature}
					/>
				</Step>

				<Step stepNumber={7} currentStep={currentStep}>
					<Pdpa
						isAdmin={isAdmin}
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
						handleUpdateSignature={handleUpdateSignature} getSignature={getSignature}
					/>
				</Step>

				<Step stepNumber={8} currentStep={currentStep}>
					<LastStep
						setCurrentStep={setCurrentStep} currentStep={currentStep}
						formValues={formValues} setFormValues={setFormValues}
					/>
				</Step>
			</LocalizationProvider>
		</div>
	);
};

export default RCAdmission;


